/* ==========================================================================
   FLRC — Article contents list
   ==========================================================================
   Used by sections/flrc-article.liquid. Builds the sticky "Contents" list from
   the article's h2 headings, gives each heading an id to link to, and marks
   the section currently being read with aria-current.

   The nav ships `hidden`, so with no JS (or an article with fewer than two
   h2s) nothing renders. Numbering matches the CSS counter on the h2s.
   ========================================================================== */

(() => {
  const init = () => {
    const nav = document.querySelector('[data-flrc-toc]');
    const list = nav?.querySelector('[data-flrc-toc-list]');
    const content = document.querySelector('[data-flrc-article-content]');
    if (!content) return;

    // Older posts carry editor spacer paragraphs (<p>&nbsp;</p>) that CSS
    // :empty can't catch; spacing comes from the stylesheet instead.
    content.querySelectorAll('p').forEach((p) => {
      if (!p.querySelector('img, iframe, video') && !p.textContent.replace(/\u00a0/g, '').trim()) p.remove();
    });

    if (!nav || !list) return;

    const headings = [...content.querySelectorAll('h2')].filter((h) => h.textContent.trim());
    if (headings.length < 2) return;

    const used = new Set();
    const slug = (text) => {
      const base =
        text
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .slice(0, 60) || 'section';
      let id = base;
      let n = 2;
      while (used.has(id) || document.getElementById(id)) id = `${base}-${n++}`;
      used.add(id);
      return id;
    };

    const links = headings.map((heading, i) => {
      if (!heading.id) heading.id = slug(heading.textContent);

      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.dataset.index = String(i + 1).padStart(2, '0');
      link.textContent = heading.textContent.trim().replace(/\?$/, '');

      const item = document.createElement('li');
      item.append(link);
      list.append(item);
      return link;
    });

    nav.hidden = false;

    const setCurrent = (index) => {
      links.forEach((link, i) => link.setAttribute('aria-current', i === index ? 'true' : 'false'));
    };

    // The current section is the last heading that has scrolled above the
    // reading line (a third of the way down the viewport).
    let ticking = false;
    const update = () => {
      ticking = false;
      const line = window.innerHeight / 3;
      let current = -1;
      headings.forEach((heading, i) => {
        if (heading.getBoundingClientRect().top <= line) current = i;
      });
      setCurrent(current);
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', update);
    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
